import styled, { css } from 'styled-components';


export const SelectAccount = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: ${theme.v2.font.lineHeight.text};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0px 0px 24px 0px
  `}
`;

export const PaypalContentWrapper = styled.div`
  align-items:center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 100%;
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 24px 0px 0px 0px;
  max-width: 280px;
  width: 100%;
`;

export const AlertWrapper = styled.div`
  ${({ theme }) => css`
    margin: 20px;
    width: calc(100% - 40px);

    > div {
      align-items: center;
      background-color: ${theme.v2.colors.brand.primaryLowLight}
      display: flex;
      padding: 8px;
    }
  `}
`;

export const Directions = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: ${theme.v2.font.lineHeight.text};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 24px 0px 0px 0px
  `}
`;
